import api from "../services/authService";

/**
 * The VBMS downloaders' work list (dms_backend #2769; Matthew, 2026-10-31).
 *
 * `GET /efolder-pulls/queue/` returns three lists — `needs_pull`, `parked`,
 * `pulled` — plus `counts` and the cutoff date `since`. Each pulled row
 * carries `progress` ({step, text}) and `problems` ([{code, text, action,
 * detail}]) in plain words; the page renders them as-is.
 *
 * Privacy: rows carry veteran names and zip names. Nothing here logs one.
 */

const data = (promise) => promise.then((response) => response.data);

export const fetchPullQueue = async () => data(api.get("/efolder-pulls/queue/"));

const action = (matterId, name, body = {}) =>
  data(api.post(`/efolder-pulls/${encodeURIComponent(matterId)}/${name}/`, body));

/** Hide a matter for `days` (default a week): "VA hasn't processed our 21-22 yet". */
export const parkMatter = (matterId, { days, note } = {}) => action(matterId, "park", { days, note });
export const unparkMatter = (matterId) => action(matterId, "unpark");
/** This matter never needs a pull (opened in error, duplicate, ...). */
export const dismissMatter = (matterId, reason = "") => action(matterId, "dismiss", { reason });
export const restoreMatter = (matterId) => action(matterId, "restore");
/** Flag for help: stored on the row and emailed to Matthew and Brendan. */
export const flagMatter = (matterId, { note, problems } = {}) =>
  action(matterId, "flag", { note, problems: (problems || []).map((p) => ({ text: p.text, code: p.code })) });
export const resolveFlag = (matterId) => action(matterId, "resolve-flag");
/** Re-queue this matter's failed AI reads (the matter page's own Retry). */
export const retryMatter = (matterId) => action(matterId, "retry");

/** What the one button on a problem row says. */
export const ACTION_LABEL = {
  upload_again: "Upload again",
  retry: "Retry",
  flag: "Flag for help",
  open_matter: "Open the file",
};

/** The queue keeps refreshing while any pulled row is still moving. */
export const queueIsMoving = (queue) =>
  (queue?.pulled || []).some((row) => !["done", "failed", "aborted"].includes(row?.progress?.step));
